import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const TryAgainButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');
    return (<Button startIcon={<ReplayIcon />} disabled={props.disabled} onClick={e => {e.stopPropagation(); props.onClick && props.onClick()}} variant="contained" color="primary">{t('tryAgain')}</Button>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));